module.exports = __webpack_public_path__ + "img/two_6.85301070.png";